module.exports = __webpack_public_path__ + "src/assets/images/icons/common/header//icn-default-profile.svg";